import api from '@/api/notification'

const state = {

}

const actions = {
  getNotificationCount ({ commit }) {
    return api.getNotificationCount()
  },
  getNotificationList ({ commit }, params) {
    return api.getNotificationList(params)
  },
  getNotificationDetail ({ commit }, notificationId) {
    return api.getNotificationDetail(notificationId)
  }

}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
